import type { Question } from '../models/Question';
import type { Group } from '../models/Group';
import type { Section } from '../models/Section';
import type { FormService } from './formService';

export interface IDisplayService {
  showQuestion(question: Question, group: Group): boolean;
  showGroup(group: Group): boolean;
  showSection(section: Section): boolean;
  showCallout?(id: string): boolean;
}

export class DisplayService implements IDisplayService {
  constructor(protected formService: FormService) {}

  public showQuestion(_question: Question, _group: Group): boolean {
    return true;
  }

  public showGroup(_group: Group): boolean {
    return true;
  }

  public showSection(_section: Section): boolean {
    return true;
  }

  public showCallout(_id: string): boolean {
    return true;
  }
}
